module.exports = __webpack_public_path__ + "static/media/icon2.92a75b0e.svg";